import styled from 'styled-components';
import FormattedNumber from 'react-number-format';
import { nepal, paradigmLightBlue } from '@paradigm/design-system/src/colors';

const FormatterInput = styled(FormattedNumber).attrs<{
  disabled: boolean;
}>((props) => ({
  inputMode: 'decimal',
  disabled: props.disabled,
}))`
  color: ${nepal};
  border: none;
  margin: 0.5rem 0;
  border-bottom: solid 2px ${paradigmLightBlue}88;
  width: 100%;
  background-color: unset;

  &:focus {
    outline: none;
    border-bottom: solid 2px ${paradigmLightBlue};
  }
  &:disabled {
    opacity: 0.3;
  }
`;

export default FormatterInput;
